<template>
  <card class="company" @click="showCompanyJobs" :footer="true">
    <div class="media">
      <div class="media-left is-relative">
        <hv-image size="is-64x64" :src="companyImage" @click="showCompanyJobs">
        </hv-image>
      </div>
      <div class="media-content">
      </div>
      <div class="media-right has-text-right">
        <h2 class="is-jobs-counter is-5 m-b-8" >
          {{getJobsCount}} jobs
        </h2>
      </div>
    </div>
    <h2 class="company-title text-overflow m-b-12">{{ company.name }}</h2>
    <p class="company-info m-b-4">
      {{getBio}}
    </p>
    <template slot="footer">
      <single-section>
        <template slot="section">
          {{this.$t("widget.viewJobsAndCompany")}}
        </template>
      </single-section>
    </template>
  </card>
</template>

<script>
import Card from '@/components/general/card'
import SingleSection from '@/components/general/single-section'
import HvImage from '@/components/general/image'
import {mapMutations} from 'vuex'

export default {
  name: 'CompanyCard',
  components: {
    Card,
    SingleSection,
    HvImage
  },
  props: {
    company: {
      type: Object,
      required: true
    },
    isCompanyPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    companyImage () {
      return this.company.imageUrl || `/api/identicons/${this.company.id}`
    },
    getBio () {
      return this.company.bio ? this.company.bio : 'Company description coming soon...'
    },
    getJobsCount () {
      return this.company.hasOwnProperty('jobsCount') ? this.company.jobsCount : 0
    }
  },
  methods: {
    ...mapMutations('companies', [
      'resetJobs'
    ]),
    ...mapMutations('widget', ['resetCompanyTalentPage']),
    ...mapMutations('HirerProfile', ['setCompany']),
    showCompanyJobs () {
      this.resetJobs([])
      this.setCompany(null)
      this.resetCompanyTalentPage()
      if (this.isCompanyPage) {
        this.$router.push(`hirer/${this.company.id}`)
      } else {
        this.$router.push(`/widget/hirer/${this.company.id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.company {
  cursor: pointer;
}

.company:hover {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.is-jobs-counter {
  font-size: 1rem;
  font-weight: 600;
}

.company-title {
  font-size: 1.25rem;
  font-weight: 600;
}

p.company-info {
  font-size: 0.875rem;
  line-height: 21px;
  height: 84px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/company-card-widget.vue